export default __webpack_public_path__ + "static/media/SafePal.e7068bbc.svg";